export enum ActivityType {
  TRANSFER_RECEIVED = 'TRANSFER_RECEIVED',
  DOCUMENT_RESET = 'DOCUMENT_RESET',
  DOCUMENT_SIGNED = 'DOCUMENT_SIGNED',
  SUBSCRIPTION_COMPLETED = 'SUBSCRIPTION_COMPLETED',
  SUBSCRIPTION_VALIDATED = 'SUBSCRIPTION_VALIDATED',
  INVEST_AMOUNT_REVIEWED = 'INVEST_AMOUNT_REVIEWED',
}
